import { render, staticRenderFns } from "./ParentInfoStep.vue?vue&type=template&id=0a634fbe&"
import script from "./ParentInfoStep.vue?vue&type=script&lang=ts&"
export * from "./ParentInfoStep.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports